import {Component, Input, OnInit} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {newGuid} from '../question-helper';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';

@Component({
    selector: 'app-question-claim-confirmation',
    templateUrl: './question-claim-confirmation.component.html',
    styleUrls: ['./question-claim-confirmation.component.scss'],
    standalone: false
})
export class QuestionClaimConfirmationComponent implements OnInit {

  @Input() question: Question;
  @Input() readonly = false;
  claim: any ;

  uniqueControlName = `question-claim-confirmation-${newGuid()}`;

  constructor(
    public globalQuestionService: GlobalQuestionService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery
  )
  {

  }

  ngOnInit(): void {
    console.log(this.question);
    this.globalQuestionService.updateClaim(this.question.cent_aq_question_id, 2).subscribe();
    const session_details = this.questionFlowSessionQuery.getValue();
    const parameters = new Map<string, string>();
    parameters.set('session_id', session_details?.session_id);

    this.globalQuestionService.runCommandNew('getClaimRefNo', parameters).subscribe(claim => {
      console.log(claim);
      this.claim = claim[0];
    });
  }

}
